import {ResourceIconPipe} from "./icons/resource.icone.pipe";
import {FaxRappelComponent} from "./dialog/dialg-fax-rappel/dialog-fax-rappel.component";
import {HprimRappelComponent} from "./dialog/dialog-hprim-rappel/dialog-hprim-rappel.component";
import {HprimFaxDialog} from "@common/utils/dialog/dialog-hprim-fax.component";
import {ResourceTemplatePipe} from "./template/resource.template.pipe";
import {AsiFilterPipe} from "./filter/asi.filter.pipe";
import {i18nModule} from "@config/i18n.module";
import {NgModule} from "@angular/core";
import {HttpModule} from "@angular/http";
import {CommonModule,DatePipe} from "@angular/common";
import {ResourcesModule} from "@resources/resources.module";

import {ResourceMultimediaPipe} from "./image/resource.multimedia.pipe";
// Form
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {DigiCerbaCommonModule} from "@digicerba/common";
import {DonneesManquantesComponent} from "@utils/dialog/dialog-donnees-manquantes/donnees-manquantes-component-dialog.component";
import {BodyDonneesManquantes} from "@utils/dialog/dialog-donnees-manquantes/body-donnees-manquantes/body-donnees-manquantes";
import {
    BodyDocumentsManquants
} from "@utils/dialog/dialog-donnees-manquantes/body-documents-manquants/body-documents-manquants";

/** liste des components / directive à exporter */
var sharedDeclaration: Array<any> = [
  ResourceMultimediaPipe, AsiFilterPipe, ResourceTemplatePipe, ResourceIconPipe
];

/** liste des modules à exporter */
var sharedModules: Array<any> = [
  FormsModule, ReactiveFormsModule, CommonModule, ResourcesModule, i18nModule
];

/** Liste des composants interne au module */
var declarations: Array<any> = [HprimRappelComponent, FaxRappelComponent, DonneesManquantesComponent, BodyDonneesManquantes];

/** Liste des services */
var services: Array<any> = [AsiFilterPipe,DatePipe ];

/** Liste des composants necessitant la création d'une factory */
var entryComponents: Array<any> = [HprimFaxDialog, DonneesManquantesComponent,BodyDonneesManquantes];

@NgModule({
  imports: [DigiCerbaCommonModule.forRoot(), HttpModule, ...sharedModules],
    declarations: [...sharedDeclaration, ...declarations, ...entryComponents, BodyDocumentsManquants],
  exports: [DigiCerbaCommonModule, ...sharedDeclaration, ...sharedModules],
  entryComponents: entryComponents,
  providers: services,
})
export class UtilsModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/utils/utils.module.ts